import * as React from "react";
const SvgFiRrUsersClass = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-users-class_svg__a)">
      <path
        fill="#062147"
        d="M4.5 18a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5m15 1c-1.472 0-2.797.735-3.624 1.864A4.98 4.98 0 0 0 12 19a4.98 4.98 0 0 0-3.876 1.864C7.297 19.735 5.972 19 4.5 19a4.52 4.52 0 0 0-4.454 3.858 1 1 0 0 0 .848 1.132 1.007 1.007 0 0 0 1.131-.849A2.51 2.51 0 0 1 4.5 20.999c1.236 0 2.3.921 2.475 2.142.071.499.536.858 1.025.858.446 0 .979-.3 1.094-.751A3 3 0 0 1 12 20.999a3 3 0 0 1 2.906 2.249c.116.45.65.749 1.094.751.539.073.947-.312 1.025-.858a2.51 2.51 0 0 1 2.475-2.142c1.236 0 2.3.921 2.475 2.142.071.499.536.858 1.025.858.547-.078 1.033-.595.954-1.142C23.64 20.658 21.725 19 19.5 19m2.5-3.5a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0m-7.5 0a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0M19 0H5C2.243 0 0 2.243 0 5v6a1 1 0 1 0 2 0V5c0-1.654 1.346-3 3-3h14c1.654 0 3 1.346 3 3v6a1 1 0 1 0 2 0V5c0-2.757-2.243-5-5-5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-users-class_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrUsersClass;
